export const BIRTH_LIST_REQUEST = 'BIRTH_LIST_REQUEST'
export const BIRTH_LIST_SUCCESS = 'BIRTH_LIST_SUCCESS'
export const BIRTH_LIST_FAIL = 'BIRTH_LIST_FAIL'
